import React from 'react';

const ErrorPage = () => {
  
  // javascript does here





  return (
    <div>
      Error 404. Fuck me, right?
    </div>
  )
}

export default ErrorPage;